module.exports = __webpack_public_path__ + "static/img/baoming_b.4b741974.png";